/**
 * @generated SignedSource<<615e0ce5f1ed8763994490a223d51b24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentSuggestedPromptsListRefetchQuery$variables = {
  id: string;
};
export type ContentSuggestedPromptsListRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ContentSuggestedPromptsListContentFragment">;
  } | null;
};
export type ContentSuggestedPromptsListRefetchQuery = {
  response: ContentSuggestedPromptsListRefetchQuery$data;
  variables: ContentSuggestedPromptsListRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentSuggestedPromptsListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContentSuggestedPromptsListContentFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentSuggestedPromptsListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "richEditorDescriptionContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasUnprocessedMediaAssets",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasProcessedMediaAssets",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "last",
                    "value": 3
                  }
                ],
                "concreteType": "BrainSearchRelatedQuestionNodeConnection",
                "kind": "LinkedField",
                "name": "brainSearchRelatedQuestions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BrainSearchRelatedQuestionNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrainSearchRelatedQuestion",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrainSearch",
                            "kind": "LinkedField",
                            "name": "viewerBrainSearch",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrainSearchMessage",
                            "kind": "LinkedField",
                            "name": "viewerBrainSearchMessage",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "brainSearchId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "brainSearchRelatedQuestions(last:3)"
              }
            ],
            "type": "Content",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f3b4b5fde14218ff9bdd7a162d368786",
    "id": null,
    "metadata": {},
    "name": "ContentSuggestedPromptsListRefetchQuery",
    "operationKind": "query",
    "text": "query ContentSuggestedPromptsListRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ContentSuggestedPromptsListContentFragment\n    id\n  }\n}\n\nfragment ContentSuggestedPromptListItemQuestion on BrainSearchRelatedQuestion {\n  id\n  text\n  viewerBrainSearch {\n    id\n  }\n  viewerBrainSearchMessage {\n    id\n    brainSearchId\n  }\n}\n\nfragment ContentSuggestedPromptsListContentFragment on Content {\n  id\n  richEditorDescriptionContent\n  hasUnprocessedMediaAssets\n  hasProcessedMediaAssets\n  brainSearchRelatedQuestions(last: 3) {\n    edges {\n      node {\n        id\n        ...ContentSuggestedPromptListItemQuestion\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4dcb9ea585c9e32a1963babb523995e6";

export default node;
